import React from 'react';
import cx from 'classnames';
import {LayoutContext} from '../ProductPageApp/ProductPageApp';
import {Text} from '@wix/wix-ui-tpa/cssVars';
import s from './ProductName.scss';
import {classes as productNameStyles} from './ProductName.st.css';
import {ProvidedGlobalProps, withGlobalProps} from '../../providers/globalPropsProvider';
import {HeadingTags} from '@wix/wixstores-client-core/dist/es/src/types/heading-tags';
import {SPECS} from '../../specs';

export interface ProductNameProps extends ProvidedGlobalProps {
  name: string;
}

export const ProductNameDataHook = 'product-title';

class ProductNameComp extends React.Component<ProductNameProps> {
  private renderProductNameWithoutHtmlTag(layoutName: string, alignFontSize: boolean): JSX.Element {
    return (
      <h1
        data-hook={ProductNameDataHook}
        className={cx(s.productName, s[`productName__${layoutName}`], {[s.alignFontSize]: alignFontSize})}>
        {this.props.name}
      </h1>
    );
  }

  private renderProductNameWithHtmlTag(
    layoutName: string,
    titleHtmlTag: HeadingTags,
    alignFontSize: boolean
  ): JSX.Element {
    return (
      <Text
        tagName={titleHtmlTag}
        data-hook={ProductNameDataHook}
        className={cx(
          s.productNameWithHtmlTag,
          s[`productNameWithHtmlTag__${layoutName}`],
          productNameStyles.root,
          productNameStyles[layoutName],
          {
            [s.alignFontSize]: alignFontSize,
            [productNameStyles.alignFontSize]: alignFontSize,
          }
        )}>
        {this.props.name}
      </Text>
    );
  }

  public render(): JSX.Element {
    const {
      globals: {htmlTags, experiments, isQuickView, useExperiments},
    } = this.props;
    const shouldRenderHtmlTag = experiments.productNameHtmlTag && !isQuickView;
    const alignFontSize = useExperiments.enabled(SPECS.PPAlignFontSizeToModernLayout);

    return (
      <LayoutContext.Consumer>
        {(layoutName) =>
          shouldRenderHtmlTag
            ? this.renderProductNameWithHtmlTag(layoutName, htmlTags.titleHtmlTag, alignFontSize)
            : this.renderProductNameWithoutHtmlTag(layoutName, alignFontSize)
        }
      </LayoutContext.Consumer>
    );
  }
}

export const ProductName = withGlobalProps(ProductNameComp);
